module.exports = __webpack_public_path__ + "img/Newbie_Axe_01_Classic.ea0407f4.png";